import styled from '@emotion/styled';

export const ErrorTextWrapper = styled.div`
  padding: 12px;
  font-size: 12px;
  color: #000;
`;
